module.exports = __webpack_public_path__ + "img/top-function-business.826feec0.jpg";